export default __webpack_public_path__ + "static/mask-desktop-e70aad114a1ce0942bdb1c1fd1388a6f.png";